import Callout from "components/callout/callout"
import DateTime from "@/components/text/DateTime"
import useNotifications from "@/hooks/useNotifications"
import { FormStatus } from "@/types"
import { useTranslation } from "react-i18next"

interface ViewNotificationProps {
    notificationId: string
}

const ViewNotification: React.FC<ViewNotificationProps> = ({ notificationId }) => {
    const { t } = useTranslation()
    const { notifications, notificationsStatus } = useNotifications()
    const notification = notifications.find((entry) => entry.id === notificationId)

    if (!notificationId) return <Callout type="error">{t("Missing notificationId")}</Callout>
    if (notificationsStatus === FormStatus.LOADING) return <Callout type="neutral" loadingIcon={true}>{t("loadingNotification")}</Callout>
    if (notificationsStatus === FormStatus.ERROR) return <Callout type="error">{t("errorLoadingData")}</Callout>
    if (!notification) return <Callout type="error">{t("errorNotificationNotFound")}</Callout>

    return (
        <div className="flex flex-col gap-3 pb-4">
            <DateTime timestamp={notification.createdAt} className="text-sm text-gray-500" />
            <p className="whitespace-pre-wrap">{notification.message}</p>
        </div>
    )
}

export default ViewNotification
